import api from './index'

const contactService = {
    getContacts: async () => {
        try {
            const res = await api.get('/api/v1/user/contacts')
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch contacts'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    getContact: async (contactId) => {
        try {
            const res = await api.get(`/api/v1/user/contacts/${contactId}`)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch contact'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    createContact: async (contactData) => {
        try {
            const res = await api.post('/api/v1/user/contacts', contactData)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to create contact'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    updateContact: async (contactId, contactData) => {
        try {
            const res = await api.put(`/api/v1/user/contacts/${contactId}`, contactData)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || `Failed to update contact with ID ${contactId}:`
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    deleteContact: async (contactId) => {
        try {
            const res = await api.delete(`/api/v1/user/contacts/${contactId}`)
            return { success: true, data: res.data }
        } catch (error) {
            console.error(`Failed to delete contact with ID ${contactId}:`, error)
            return { success: false, message: `Failed to delete contact with ID ${contactId}` }
        }
    },
}

export default contactService
